var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tool-iclock flex-c-c",style:(_vm.eleStyle)},[_c('canvas',{ref:"iclock",attrs:{"id":"iclock","width":parseInt(_vm.winSize.wh * _vm.ratio),"height":parseInt(_vm.winSize.wh * _vm.ratio)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }